export default "__VITE_ASSET__CukwarAL__"